import React from 'react';
import { Popup } from 'react-map-gl';
import useGlobalState from '../../hooks/use-global-state';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faTimes,
} from '@fortawesome/pro-solid-svg-icons';
import { format } from 'date-fns';
import { colors } from '../../modules/theme';
import { H3, H4, Span } from '../ui';
import { setActiveSubmissions } from '../../modules/app-duck';

const IconBtn = props => (
  <button
    css={{
      cursor: 'pointer',
      fontSize: 14,
      border: 'none',
      background: 'none',
      color: 'white',
    }}
    {...props}
  >
    {props.children}
  </button>
);

export default function FrogPopup() {
  const { state, dispatch } = useGlobalState();
  const { activeSubmissions } = state;
  const [activeSubmissionIndex, setActiveSubmissionIndex] = useState(0);
  const activeSubmission = activeSubmissions[activeSubmissionIndex];
  const activeFrog = state.frogsById[activeSubmission.frog_species_id];

  return (
    <Popup
      css={{ zIndex: 20 }}
      latitude={activeSubmissions[0].lat}
      longitude={activeSubmissions[0].lng}
      closeButton={false}
      dynamicPosition={true}
    >
      <div
        css={{
          width: 300,
          borderRadius: 4,
          border: '1px solid rgba(255,255,255,0.5)',
          background: colors.lightBlue,
          color: 'white',
        }}
      >
        {activeSubmissions.length > 1 && (
          <div
            css={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 14,
            }}
          >
            <IconBtn
              onClick={e => {
                if (activeSubmissionIndex === 0) {
                  setActiveSubmissionIndex(activeSubmissions.length - 1);
                  return;
                }
                setActiveSubmissionIndex(activeSubmissionIndex - 1);
              }}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </IconBtn>
            <span css={{ margin: '0 5px' }}>
              Record {activeSubmissionIndex + 1}/{activeSubmissions.length}
            </span>
            <IconBtn
              onClick={e => {
                if (activeSubmissionIndex === activeSubmissions.length - 1) {
                  setActiveSubmissionIndex(0);
                  return;
                }
                setActiveSubmissionIndex(activeSubmissionIndex + 1);
              }}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </IconBtn>
          </div>
        )}
        {activeFrog ? (
          <div>
            <IconBtn
              onClick={() => dispatch(setActiveSubmissions([]))}
              css={{
                position: 'absolute',
                top: 0,
                right: 0,
                padding: 10,
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </IconBtn>
            <div
              css={{ display: 'flex', background: colors.blue, padding: 10 }}
            >
              <img
                css={{
                  height: 46,
                  width: 46,
                  border: '1px solid #FFFFFF',
                  marginRight: 10,
                  borderRadius: '50%',
                  flexShrink: 0,
                  objectFit: 'cover',
                }}
                src={activeFrog.image_url}
                alt={activeFrog.common_name}
              />
              <div>
                <H3 css={{ paddingRight: 13 }}>{activeFrog.common_name}</H3>
                <H4 css={{ fontStyle: 'italic' }}>{activeFrog.latin_name}</H4>
                <hr css={{ margin: '10px 0', opacity: 0.2 }} />
                <H4 css={{ fontWeight: 'normal' }}>
                  Date: {format(activeSubmission.date, 'DD MMMM YYYY')}
                </H4>
                {activeSubmission.obscured && (
                  <Span
                    css={{
                      fontWeight: 'normal',
                      lineHeight: 0.8,
                      fontStyle: 'italic',
                    }}
                  >
                    Please note the exact location for this frog species has
                    been obscured.
                  </Span>
                )}
              </div>
            </div>

            <a
              href={activeFrog.profile_url}
              target="_blank"
              rel="noopener noreferrer"
              css={{
                display: 'block',
                margin: '10px auto',
                color: colors.blue,
                background: 'white',
                padding: 5,
                textAlign: 'center',
                border: 'none',
                width: 133,
                textDecoration: 'none',
                borderRadius: '3px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              View frog profile
            </a>
          </div>
        ) : (
          <p>Missing frog</p>
        )}
      </div>
    </Popup>
  );
}
